import Tracker from './Tracker';

const prospectingTracker = new Tracker('prospecting', {
	BULK_SAVE: 'bulkSave',
	TOGGLE_IN_UPSALES: 'toggleInUpsales'
});

export default prospectingTracker;
